import {theme} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'
import './ZoomScaleLine.less'

const zoomScaleLineReferences = [{}]

function calculateScaleReference(
  scaleWidth: number,
  scaleReferencesInCm: number[],
  pixelsPerCm: number
) {
  for (let index = 0; index < scaleReferencesInCm.length; ++index) {
    if (scaleWidth / (scaleReferencesInCm[index] * pixelsPerCm) > 2) {
      return {
        m: scaleReferencesInCm[index] / 100,
        pixels: scaleReferencesInCm[index] * pixelsPerCm,
      }
    }
  }
  return {
    m: '<1',
    pixels: scaleWidth,
  }
}

export function ZoomScaleLine({pixelsPerCm}: {pixelsPerCm: number}) {
  const scaleWidth = 250
  const scaleWidthInCm = scaleWidth * pixelsPerCm
  const scaleReferenceInCm = 100
  const scaleReferencesInCm = [10000, 5000, 1000, 500, 400, 300, 200, 100]
  const scaleReferenceWidthInPixels = scaleReferenceInCm * pixelsPerCm
  const maxScaleReferenceWidth = calculateScaleReference(
    scaleWidth,
    scaleReferencesInCm,
    pixelsPerCm
  )

  let fullScaleReferencesThatFit = Math.ceil(scaleWidth / maxScaleReferenceWidth.pixels)
  if (fullScaleReferencesThatFit === Infinity) {
    fullScaleReferencesThatFit = 1
  }

  const intl = useIntl()

  const {
    token: {colorPrimary, colorPrimaryBorder, borderRadiusXS},
  } = theme.useToken()

  return (
    <div style={{position: 'relative'}}>
      <div
        style={{
          width: scaleWidth + 4,
          height: 7,
          border: `1px solid ${colorPrimaryBorder}`,
          borderRadius: borderRadiusXS,
        }}
      ></div>
      <div
        style={{
          position: 'absolute',
          left: 2,
          top: 2,
          height: 3,
          right: 2,
          display: 'flex',
          flexDirection: 'row',
          overflowX: 'clip',
        }}
      >
        {Array.from({length: fullScaleReferencesThatFit}, (_, index) => (
          <div
            className="zoom-scale__segment"
            key={index}
            style={{
              width: maxScaleReferenceWidth.pixels,
              background: index % 2 === 0 ? colorPrimary : 'transparent',
              boxSizing: 'border-box',
              border: index % 2 !== 0 ? `1px solid ${colorPrimary}` : undefined,
              flex: '0 0 auto',
            }}
          >
            {index === 0 && (
              <span className="zoom-scale__segment__text">
                {maxScaleReferenceWidth.m} {intl.formatMessage({id: 'm'})}
              </span>
            )}
          </div>
        ))}
      </div>
      <div
        style={{
          color: colorPrimary,
        }}
      ></div>
    </div>
  )
}
